import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/**
 * Temporary placeholder for partner pages not yet migrated. Each later
 * extraction step (landing, betting, games, payment) replaces the corresponding
 * route element in PartnerRoutes with the real component.
 */
const ComingSoon = ({ title = 'Coming soon' }: { title?: string }) => (
    <Box sx={{ py: 8, display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
        <Stack spacing={1} alignItems="center">
            <Typography variant="h3" sx={{ color: 'secondary.main' }}>
                {title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                This screen is being migrated.
            </Typography>
        </Stack>
    </Box>
);

export default ComingSoon;
